import request from '@/config/axios'

export const getGroupbuyActivityPage = (params: Recordable) =>
  request.get({ url: '/mall/groupbuy/activity/page', params })

export const getGroupbuyActivity = (id: number) =>
  request.get({ url: '/mall/groupbuy/activity/get', params: { id } })

export const cutEarlyGroupbuyActivity = (id: number) =>
  request.put({ url: '/mall/groupbuy/activity/cut-early', params: { id } })

export const cancelGroupbuyActivity = (id: number) =>
  request.put({ url: '/mall/groupbuy/activity/cancel', params: { id } })

export const forceStopSellGroupbuyActivity = (id: number) =>
  request.put({ url: '/mall/groupbuy/activity/force-stop-sell', params: { id } })
